// Category-fit, locally served stock photography. Source and license records: IMAGE_SOURCES.md.
export const categoryImages = {
  "health-and-clinical-care": {
    src: "/public-assets/professions/categories/health-and-clinical-care-stethoscope-notebook.webp",
    alt: "Stethoscope and blank notebook on a wooden desk",
    width: 1280,
    height: 1920,
  },
  "rehabilitation-and-physical-therapy": {
    src: "/public-assets/professions/categories/rehabilitation-and-physical-therapy-seated-back-stretch.webp",
    alt: "One person demonstrating a back stretch to another in a bright room",
    width: 1280,
    height: 853,
  },
  "mental-health-and-talking-therapies": {
    src: "/public-assets/professions/categories/mental-health-and-talking-therapies-counselling-conversation.webp",
    alt: "Two people talking during a counselling session in a quiet room",
    width: 1280,
    height: 1920,
  },
  "nutrition-and-complementary-therapies": {
    src: "/public-assets/professions/categories/nutrition-and-complementary-therapies-weekly-meal-planning.webp",
    alt: "Hand writing a weekly meal plan beside fresh fruit",
    width: 1280,
    height: 1765,
  },
  "hair-beauty-and-body-art": {
    src: "/public-assets/professions/categories/hair-beauty-and-body-art-hair-trimming.webp",
    alt: "Hands trimming a client's hair",
    width: 1280,
    height: 854,
  },
  "personal-style-and-clothing": {
    src: "/public-assets/professions/categories/personal-style-and-clothing-jacket-measuring.webp",
    alt: "Hands measuring a client's jacket fitting",
    width: 1280,
    height: 853,
  },
  "fitness-sport-and-movement": {
    src: "/public-assets/professions/categories/fitness-sport-and-movement-floor-exercise-coaching.webp",
    alt: "One person guiding another through floor exercises",
    width: 1280,
    height: 720,
  },
  "education-lessons-and-training": {
    src: "/public-assets/professions/categories/education-lessons-and-training-adult-learning-session.webp",
    alt: "Two people working through a lesson at a table",
    width: 1280,
    height: 853,
  },
  "coaching-and-personal-development": {
    src: "/public-assets/professions/categories/coaching-and-personal-development-one-to-one-tablet-meeting.webp",
    alt: "Two people reviewing a tablet during a one-to-one meeting",
    width: 1280,
    height: 1920,
  },
  "childcare-and-family-support": {
    src: "/public-assets/professions/categories/childcare-and-family-support-playroom-books-toys.webp",
    alt: "Children's toys and books arranged on playroom shelves",
    width: 1280,
    height: 1280,
  },
  "home-care-disability-and-advocacy": {
    src: "/public-assets/professions/categories/home-care-disability-and-advocacy-older-person-home-support.webp",
    alt: "One person assisting an older woman at home",
    width: 1280,
    height: 853,
  },
  "pet-care-and-veterinary-services": {
    src: "/public-assets/professions/categories/pet-care-and-veterinary-services-terrier-coat-grooming.webp",
    alt: "Terrier having its coat trimmed on a grooming table",
    width: 1280,
    height: 853,
  },
  "equine-livestock-and-farm-services": {
    src: "/public-assets/professions/categories/equine-livestock-and-farm-services-horse-hoof-farrier-work.webp",
    alt: "Hands shaping a horseshoe on a horse's hoof",
    width: 1280,
    height: 853,
  },
  "building-and-construction": {
    src: "/public-assets/professions/categories/building-and-construction-timber-building-work.webp",
    alt: "Person working with timber at a building site",
    width: 1280,
    height: 853,
  },
  "plumbing-heating-and-water": {
    src: "/public-assets/professions/categories/plumbing-heating-and-water-copper-pipe-repair.webp",
    alt: "Hands working on a copper pipe clamped in a vice",
    width: 1280,
    height: 1919,
  },
  "electrical-security-and-installations": {
    src: "/public-assets/professions/categories/electrical-security-and-installations-outdoor-electrical-panel.webp",
    alt: "Worker in safety gear checking an outdoor electrical panel",
    width: 1280,
    height: 853,
  },
  "cleaning-and-restoration": {
    src: "/public-assets/professions/categories/cleaning-and-restoration-living-room-vacuuming.webp",
    alt: "Person vacuuming the floor in a living room",
    width: 1280,
    height: 853,
  },
  "waste-pests-and-environmental-services": {
    src: "/public-assets/professions/categories/waste-pests-and-environmental-services-wheeled-bin-collection.webp",
    alt: "Waste worker pushing an orange wheeled bin along a street",
    width: 1280,
    height: 853,
  },
  "gardens-grounds-and-outdoor-spaces": {
    src: "/public-assets/professions/categories/gardens-grounds-and-outdoor-spaces-hedge-trimming.webp",
    alt: "Person trimming a hedge with long-handled loppers",
    width: 1280,
    height: 853,
  },
  "property-design-surveying-and-inspection": {
    src: "/public-assets/professions/categories/property-design-surveying-and-inspection-property-window-inspection.webp",
    alt: "Person in a safety vest checking a property's window",
    width: 1280,
    height: 853,
  },
  "vehicle-cycle-and-marine-services": {
    src: "/public-assets/professions/categories/vehicle-cycle-and-marine-services-car-wiper-repair.webp",
    alt: "Hands repairing a car's wiper mechanism under the bonnet",
    width: 1280,
    height: 853,
  },
  "technology-and-equipment-support": {
    src: "/public-assets/professions/categories/technology-and-equipment-support-computer-components-workbench.webp",
    alt: "Person checking computer components at a workbench",
    width: 1280,
    height: 853,
  },
  "industrial-and-commercial-field-services": {
    src: "/public-assets/professions/categories/industrial-and-commercial-field-services-industrial-machinery-inspection.webp",
    alt: "Worker inspecting large machinery in an industrial workshop",
    width: 1280,
    height: 853,
  },
  "fitting-repair-and-craft-services": {
    src: "/public-assets/professions/categories/fitting-repair-and-craft-services-woodwork-bench.webp",
    alt: "Hands working on a wooden piece at a bench",
    width: 1280,
    height: 1920,
  },
  "transport-removals-and-deliveries": {
    src: "/public-assets/professions/categories/transport-removals-and-deliveries-boxes-delivery-van.webp",
    alt: "Person carrying cardboard boxes beside a van",
    width: 1280,
    height: 1920,
  },
  "land-agriculture-and-environmental-services": {
    src: "/public-assets/professions/categories/land-agriculture-and-environmental-services-green-crop-field.webp",
    alt: "Person walking between rows of crops in a green field",
    width: 1280,
    height: 853,
  },
  "photography-media-and-creative-work": {
    src: "/public-assets/professions/categories/photography-media-and-creative-work-camera-laptop-workflow.webp",
    alt: "Person using a camera beside a laptop",
    width: 1280,
    height: 853,
  },
  "events-and-entertainment": {
    src: "/public-assets/professions/categories/events-and-entertainment-lit-event-stage.webp",
    alt: "Lit stage in a large event venue",
    width: 1280,
    height: 853,
  },
  "food-drink-and-catering": {
    src: "/public-assets/professions/categories/food-drink-and-catering-commercial-kitchen-preparation.webp",
    alt: "Person preparing food in a commercial kitchen",
    width: 1280,
    height: 853,
  },
  "business-finance-and-legal-services": {
    src: "/public-assets/professions/categories/business-finance-and-legal-services-office-business-meeting.webp",
    alt: "Two business professionals talking across an office table",
    width: 1280,
    height: 853,
  },
  "organising-and-personal-assistance": {
    src: "/public-assets/professions/categories/organising-and-personal-assistance-packing-cardboard-box.webp",
    alt: "Hands packing household belongings into a cardboard box",
    width: 1280,
    height: 1920,
  },
  "specialist-business-field-services": {
    src: "/public-assets/professions/categories/specialist-business-field-services-site-checklist-review.webp",
    alt: "Person in a high-visibility vest reviewing a site checklist",
    width: 1280,
    height: 853,
  },
}

export function getProfessionCategoryImage(categorySlug) {
  return categoryImages[categorySlug] ?? null
}
